import Icon from '../components/Icon.vue'

Icon.register({
  'life-ring': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM429.7 127.6c-10.6-14.3-30.9-34.6-45.3-45.3l-63.4 63.4c18.6 11 34.3 26.7 45.3 45.3zM256 352c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zM127.6 82.3c-14.3 10.6-34.6 30.9-45.3 45.3l63.4 63.4c11-18.6 26.7-34.3 45.3-45.3zM82.3 384.4c10.6 14.3 30.9 34.6 45.3 45.3l63.4-63.4c-18.6-11-34.3-26.7-45.3-45.3zM384.4 429.7c14.3-10.6 34.6-30.9 45.3-45.3l-63.4-63.4c-11 18.6-26.7 34.3-45.3 45.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/life-ring.js
// module id = 1519
// module chunks = 0